import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Terms.css";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { fetchAPI } from "../utils/api";

export default function Refund() {
  const [dynamicContent, setDynamicContent] = useState("");
  const [pageName, setPageName] = useState("");
  const [pageSubtitle, setPageSubtitle] = useState("");

  useEffect(() => {
    fetchAPI("GenralController/refund_policy")
      .then((data) => {
        if (
          data.status === 200 &&
          Array.isArray(data.result) &&
          data.result.length > 0
        ) {
          setDynamicContent(data.result[0].page_description);
          setPageName(data.result[0].page_name);
          setPageSubtitle(data.result[0].page_subtitle);
        }
      })
      .catch((err) => {
        console.warn(
          "Failed to load refund policy dynamically, using static fallback",
          err,
        );
      });
  }, []);

  return (
    <>
      <Header />

      {/* <div className="second_breadcum">
        <div className="container-fluid">
          <div className="inner_second_breadcum">
            <h1>{pageName || "Refund & Cancellation Policy"} </h1>
            <div className="Sec-breadcrumb">
              <Link to="/">Home</Link>
              <span>&gt;</span>
              <span>{pageName || "Refund & Cancellation Policy"}</span>
            </div>
          </div>
        </div>
      </div> */}

      <div className="terms_main_container">
        <div className="container-fluid">
          <div className="inner_terms_pg">
            <h2 className="hading_t">{"Refund & Cancellation Policy"}</h2>

            {dynamicContent ? (
              <div
                className="content_in_pera"
                style={{
                  lineHeight: "1.8",
                  color: "#666",
                }}
                dangerouslySetInnerHTML={{ __html: dynamicContent }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
